var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0227 2.25H1.97727C1.29947 2.25 0.75 2.92157 0.75 3.75V12.75C0.75 13.5784 1.29947 14.25 1.97727 14.25H13.0227C13.7005 14.25 14.25 13.5784 14.25 12.75V3.75C14.25 2.92157 13.7005 2.25 13.0227 2.25Z",
    fill: "white",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 3.75H2.25C1.42157 3.75 0.75 4.42157 0.75 5.25V14.25C0.75 15.0784 1.42157 15.75 2.25 15.75H15.75C16.5784 15.75 17.25 15.0784 17.25 14.25V5.25C17.25 4.42157 16.5784 3.75 15.75 3.75Z",
    fill: "white",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10C8 9.44772 8.44772 9 9 9H17V13H9C8.44772 13 8 12.5523 8 12V10Z",
    fill: "white",
    stroke: "#333333"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.2da13e42dead9f5c26d7ec18e6a7217d.svg";
export { ForwardRef as ReactComponent };